import type { HostModalType, ModalLoader } from '@shared/lib/modal';

type ModalComponentRegistry = { [T in HostModalType]: ModalLoader<T> };

export const modalComponentRegistry = {} satisfies ModalComponentRegistry;
